import { render, staticRenderFns } from "./Greenhost.vue?vue&type=template&id=970dfbc0&"
import script from "./Greenhost.vue?vue&type=script&lang=js&"
export * from "./Greenhost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports